module.exports = "/images/ko.svg";